export const  GET_TUTOR_AVAILABILITY_REQUEST='tutorAvailabilityReducer/GET_TUTOR_AVAILABILITY_REQUEST';
export const  GET_TUTOR_AVAILABILITY_SUCCESS='tutorAvailabilityReducer/GET_TUTOR_AVAILABILITY_SUCCESS';
export const  GET_TUTOR_AVAILABILITY_FAILED='tutorAvailabilityReducer/GET_TUTOR_AVAILABILITY_FAILED';